export enum PaymentMethodType {
  notaAPrazo = 'nota-a-prazo',
  pumpX = 'pump-x',
}

export namespace PaymentMethodType {
  export const translateType = (type: PaymentMethodType): string => {
    switch (type) {
      case PaymentMethodType.notaAPrazo:
        return "Nota a prazo"
      case PaymentMethodType.pumpX:
        return "PumpX";
      default: return "";
    };
  };

  export const paymentMethodChoices: Array<{ id: string, name: string }> = Object.values(PaymentMethodType)
    .filter(x => typeof x === "string")
    .map((type) => ({
      id: type,
      name: PaymentMethodType.translateType(type as PaymentMethodType),
    } as { id: string, name: string }));
};